(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antes-depois-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      var compares = root.querySelectorAll('[data-izba-compare]');
      compares.forEach(function (compare) {
        if (compare.__izbaBound) return;
        compare.__izbaBound = true;
        var range = compare.querySelector('[data-izba-range]');
        if (!range) return;
        function apply() {
          compare.style.setProperty('--izba-pos', range.value);
        }
        range.addEventListener('input', apply, { passive: true });
        // Keyboard arrows already handled by the native range input.
        apply();
      });
    }

    function init() {
      bind(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-bind when a block/section is (re)loaded in the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
      bind(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meense-social-comments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('meense-comments')) {
    customElements.define('meense-comments', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.querySelectorAll('.mc-like').forEach(button => {
          const key = 'meense-comment-like:' + this.dataset.section + ':' + button.dataset.key;
          let liked = false;
          try { liked = localStorage.getItem(key) === '1'; } catch {}
          const update = () => {
            button.setAttribute('aria-pressed', String(liked));
            button.querySelector('[data-like-count]').textContent = String(Number(button.dataset.base) + Number(liked));
          };
          update();
          button.addEventListener('click', () => {
            liked = !liked;
            try { localStorage.setItem(key, liked ? '1' : '0'); } catch {}
            update();
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-produto"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      (root||document).querySelectorAll('[data-izqz]:not([data-izqz-bound])').forEach(function(q){
        q.setAttribute('data-izqz-bound','1');
        var steps   = Array.prototype.slice.call(q.querySelectorAll('[data-izqz-step]'));
        var fill    = q.querySelector('[data-izqz-fill]');
        var stepsW  = q.querySelector('[data-izqz-steps]');
        var resultsW= q.querySelector('[data-izqz-results]');
        var results = Array.prototype.slice.call(q.querySelectorAll('[data-izqz-result]'));
        var restart = q.querySelector('[data-izqz-restart]');
        var total   = steps.length;
        var cur = 0, counts = {};

        function setProgress(n){ if(fill) fill.style.width = (total ? (n/total*100) : 0) + '%'; }
        function show(i){
          steps.forEach(function(s,idx){ s.hidden = idx !== i; });
          setProgress(i);
        }
        function finish(){
          // chave mais escolhida (empate => primeira na ordem dos resultados)
          var best=null, bestN=-1;
          results.forEach(function(r){
            var k=r.getAttribute('data-key');
            var n=counts[k]||0;
            if(n>bestN){ bestN=n; best=k; }
          });
          results.forEach(function(r){ r.hidden = r.getAttribute('data-key')!==best; });
          if(stepsW) stepsW.hidden = true;
          if(resultsW) resultsW.hidden = false;
          setProgress(total);
        }
        q.querySelectorAll('[data-izqz-opt]').forEach(function(btn){
          btn.addEventListener('click', function(){
            var v = btn.getAttribute('data-value') || '';
            counts[v] = (counts[v]||0) + 1;
            cur++;
            if(cur >= total){ finish(); }
            else { show(cur); }
          });
        });
        if(restart){
          restart.addEventListener('click', function(){
            cur = 0; counts = {};
            if(resultsW) resultsW.hidden = true;
            if(stepsW) stepsW.hidden = false;
            show(0);
          });
        }
        show(0);
      });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
    else init();
    document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-destaque"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function wire(root){
      (root||document).querySelectorAll('[data-izvd]:not([data-izvd-bound])').forEach(function(frame){
        frame.setAttribute('data-izvd-bound','1');
        var btn = frame.querySelector('[data-izvd-play]');
        if(!btn) return;
        btn.addEventListener('click', function(){
          var target = frame.querySelector('[data-izvd-target]');
          var iframe = frame.querySelector('[data-izvd-iframe]');
          var video  = frame.querySelector('[data-izvd-video]');
          if(iframe && !iframe.src){ iframe.src = iframe.getAttribute('data-src') + '&autoplay=1'; }
          if(target){ target.hidden = false; }
          btn.style.display = 'none';
          if(video){ try{ video.play(); }catch(e){} }
        });
      });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){wire();});
    else wire();
    document.addEventListener('shopify:section:load', function(e){ wire(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
